import apiClient from './apiClient';

export const getEventTypes = async (authToken: string) => {
	const res = await apiClient.get('/events/types', {
		headers: {
			Authorization: authToken,
		},
	});

	return res.data;
};

export const QUERY_KEYS = {
	EVENTS_TYPES: 'events_types',
};
